export const normalizeProductName = (productName) => {
	return String(productName || '').trim().toLowerCase();
};

export const findProductByName = (products, productName) => {
	const normalizedProductName = normalizeProductName(productName);

	if (!normalizedProductName) {
		return undefined;
	}

	return (products || []).find(product => normalizeProductName(product && product.Name) === normalizedProductName);
};

export const findProductByID = (products, productID) => {
	return (products || []).find(product => product && String(product.id) === String(productID));
};

export const resolveProductNameForPayload = (products, selectedProductID, existingProductName) => {
	const selectedProduct = findProductByID(products, selectedProductID);
	if (selectedProduct && String(selectedProduct.Name || '').trim()) {
		return selectedProduct.Name;
	}

	const existingProduct = findProductByName(products, existingProductName);
	if (existingProduct) {
		return existingProduct.Name;
	}

	return String(existingProductName || '').trim();
};
